// Angular
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
// Layout
import { LayoutConfigService } from '../../../../../core/_base/layout';
// Charts
import {
  Chart,
  registerables
} from 'chart.js';

// Necessário para ativar todos os componentes do Chart.js
Chart.register(...registerables);

@Component({
  selector: 'kt-widget14',
  templateUrl: './widget14.component.html',
  styleUrls: ['./widget14.component.scss'],
})
export class Widget14Component implements OnInit {
  // Public properties
  @Input() title: string;
  @Input() desc: string;
  @Input() data: { labels: string[]; datasets: any[] };
  @ViewChild('chart', { static: true }) chart: ElementRef;

  /**
   * Component constructor
   *
   * @param layoutConfigService: LayoutConfigService
   */
  constructor(private layoutConfigService: LayoutConfigService) { }

  /**
   * On init
   */
  ngOnInit() {
    if (!this.data) {
      this.data = {
        labels: ['Label 1', 'Label 2', 'Label 3', 'Label 4', 'Label 5', 'Label 6', 'Label 7', 'Label 8', 'Label 9', 'Label 10', 'Label 11', 'Label 12', 'Label 13', 'Label 14', 'Label 15', 'Label 16'],
        datasets: [
          {
            backgroundColor: this.layoutConfigService.getConfig('colors.state.success'),
            data: [15, 20, 25, 30, 25, 20, 15, 20, 25, 30, 25, 20, 15, 10, 15, 20]
          },
          {
            backgroundColor: '#f3f3fb',
            data: [15, 20, 25, 30, 25, 20, 15, 20, 25, 30, 25, 20, 15, 10, 15, 20]
          }
        ]
      };
    }

    this.initChartJS();
  }

  /** Init chart */
  initChartJS() {
    const chart = new Chart(this.chart.nativeElement, {
      type: 'bar',
      data: this.data,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: false
          },
          tooltip: {
            enabled: true,
            intersect: false,
            mode: 'nearest',
            padding: 10
          },
          legend: {
            display: false
          }
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          }
        },
        scales: {
          x: {
            type: 'category',
            display: false,
            stacked: true,
            grid: {
              display: false
            }
          },
          y: {
            type: 'linear',
            display: false,
            stacked: true,
            grid: {
              display: false
            },
            beginAtZero: true  // ✅ Correto: direto aqui, não dentro de `ticks`.
          }
        }
      }
    });
  }
}
